<template>
    <div class="content">
        <router-view @refresh="refresh()"></router-view>
        <header class="content-header">
            <div class="wrapper">

                <div>
                    <h1>Slots</h1>
                    <p>Gestion des slots du calendrier</p>

                    <div class="datagrid-results"><strong>{{paginator.total}}</strong> Résultats trouvés</div>
                </div>

              <actions-dropdown>
                <li v-if="$aclInterfaceValidator('weeboxcore.slotable.create')" class="main" @click="create()">
                  <icon name="file-plus-02"/>
                  <span>Créer un slot</span>
                </li>
              </actions-dropdown>


            </div>
        </header>

        <filters v-model="filters" :localesProp="locales" :paginator="paginator" :menus="menus" active-advanced-filter="false"  @refresh="refresh()" @setInputsValue="setInputsValue" @setFilter="setFilter"></filters>

        <div class="content-body">

            <section>

                <no-results v-model="resources" :clear="resetFilter"></no-results>

                <div v-if="resources && resources.length" class="datagrid" :class="paginator.listing">
                    <div class="datagrid-header">
                        <div>

                            <div></div>
                            <div class="center">
                              <datagrid-sort :data="[{name:'ID', value:'id'}]" v-model="paginator"></datagrid-sort>
                            </div>
                            <div>
                              <span>Succursale</span>
                            </div>
                            <div>
                              <datagrid-sort :data="[{name:'Nom', value:'name'}]" v-model="paginator"></datagrid-sort>
                            </div>
                            <div>
                              <datagrid-sort :data="[{name:'Couleur', value:'color'}]" v-model="paginator"></datagrid-sort>
                            </div>
                            <div class="center">
                              <span>Abonnement .ics</span>
                            </div>
                          <div class="center">
                            <span>Fichier .ics</span>
                          </div>
                            <div>
                                <span>Public</span>
                            </div>
                            <div class="actions"></div>
                            <div></div>

                        </div>
                    </div>
                    <div class="datagrid-body">
                        <div v-for="item in resources" @dblclick="edit(item.id)" v-bind:class="setClassDataRaw( 'weeboxcore.slotable.view', item.id )">
                            <div></div>
                            <div data-field="id" class="center"><span class="id">{{ item.id }}</span></div>
                            <div data-field="name">
                                <span class="branch-name">{{ item.slotable.name }}</span>
                                <span class="branch-locality">{{ item.slotable.postal_code }} {{ item.slotable.locality }}</span>
                            </div>
                            <div data-field="name">{{ item.name }}</div>
                            <div data-field="color"><label class="label scope" v-bind:style="{background:item.color}"></label></div>
                            <div class="center"><a @click="copyPaste($event)"><input type="text" :value="item.link" v-on:focus="$event.target.select()" style="position: absolute;z-index:-1;pointer-events: none;"/> <i class="icon icon-calendar"></i> Copier le lien</a></div>
                          <div class="center"><a :href="item.link" target="_blank"> <i class="icon icon-calendar"></i> Télécharger</a></div>
                          <div data-field="is_public"><checked v-model="item.is_public"></checked></div>
                            <div class="actions">
                                <ul>
                                    <li v-if="$aclInterfaceValidator('weeboxcore.slotable.delete',item.id)"><button @click="remove(item.id)"><icon name="trash-01"/></button></li>
                                    <li v-if="$aclInterfaceValidator('weeboxcore.slotable.update',item.id)"><button @click="edit(item.id)"><icon name="pencil-02"/></button></li>
                                </ul>
                            </div>
                            <div></div>
                        </div>
                    </div>
                </div>
            </section>

            <component-paginator v-model="paginator" v-on:refresh="refresh"></component-paginator>

        </div>
    </div>
</template>
<script>
    import SlotableService from './SlotableService.js';
    import BranchService from '../branch/BranchService.js';
    import Index from '../../../layouts/Index.vue';

    export default {
        extends: Index,
        data () {
            return {
                locales: null,
                menus: [
                    {
                        slug: 'calendar',
                        name: 'Slots'
                    },
                    {
                        slug: 'opening-hours',
                        name: 'Horaire ouverture'
                    },
                    {
                        slug: 'closure',
                        name: 'Vacances / Fermeture'
                    }
                ]
            }
        },
        mounted: function(){
            this.refresh();

            BranchService.query().then(response => {
                this.filters.inputs.push({
                    name: 'Succursale',
                    slug: 'branch',
                    type: 'select',
                    mandatory: false,
                    options: response.data.data,
                    has_languages: false,
                    value: null,
                });
            });

        },
        watch: {
        },
        methods: {
            copyPaste: function(e){
              //this.$refs.myinput.focus();
              e.target.querySelector('input').focus();
              document.execCommand('copy');
              alert("Le lien a été copié")
            },
            getResource: function(){
                return SlotableService;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/config/calendar/Index.vue